<template>
  <div class="loader--overlay" :class="{'loader--overlay-show': active}">
    <div class="loader--container">
      <svg class="loader--circular" viewBox="25 25 50 50">
        <circle class="loader--path" cx="50" cy="50" r="20" fill="none" stroke-width="4"
                stroke-miterlimit="10"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.loader--overlay {
  position: fixed;
  z-index: 35;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  visibility: hidden;
  opacity: 0;

  -webkit-transition: opacity 250ms ease-in, visibility 1ms linear 250ms, background-color 250ms ease-in 250ms;
  transition: opacity 250ms ease-in, visibility 1ms linear 250ms, background-color 250ms ease-in 250ms;
}

.loader--overlay-show {
  visibility: visible;
  opacity: 1;

  -webkit-transition: opacity 250ms ease-out, visibility 1ms linear 1ms, background-color 250ms ease-out 1ms;
  transition: opacity 250ms ease-out, visibility 1ms linear 1ms, background-color 250ms ease-out 1ms;
}

.loader--overlay-clear {
  background-color: rgba(0, 0, 0, 0);

  -webkit-transition: opacity 250ms ease-out, visibility 1ms linear 1ms, background-color 0ms linear 1ms;
  transition: opacity 250ms ease-out, visibility 1ms linear 1ms, background-color 0ms linear 1ms;
}

.loader--container {
  visibility: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -50px 0 0 -50px;
  width: 100px;
  height: 100px;
  opacity: 0;

  -webkit-transition: opacity 250ms ease-in, visibility 1ms linear 250ms;
  transition: opacity 250ms ease-in, visibility 1ms linear 250ms;
}

.loader--overlay-show .loader--container {
  visibility: visible;
  opacity: 1;

  -webkit-transition: opacity 250ms ease-out, visibility 1ms linear 1ms;
  transition: opacity 250ms ease-out, visibility 1ms linear 1ms;
}

.loader--circular {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transform-origin: center center;
  animation: loader-rotate 2000ms linear infinite;

  animation-play-state: paused;
}

.loader--path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: loader-dash 1500ms ease-in-out infinite, loader-color 6000ms ease-in-out infinite;

  animation-play-state: paused;
}

.loader--overlay-show .loader--circular,
.loader--overlay-show .loader--path {
  animation-play-state: running;
}

@-webkit-keyframes loader-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loader-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader-dash {
  from {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes loader-dash {
  from {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@-webkit-keyframes loader-dash-small {
  from {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 67, 200;
    stroke-dashoffset: -23px;
  }
  100% {
    stroke-dasharray: 67, 200;
    stroke-dashoffset: -93px;
  }
}

@keyframes loader-dash-small {
  from {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 67, 200;
    stroke-dashoffset: -23px;
  }
  100% {
    stroke-dasharray: 67, 200;
    stroke-dashoffset: -93px;
  }
}

@-webkit-keyframes loader-color {
  100%,
  from {
    stroke: #d62d20;
  }
  40% {
    stroke: #0057e7;
  }
  66% {
    stroke: #008744;
  }
  80%,
  90% {
    stroke: #ffa700;
  }
}

@keyframes loader-color {
  100%,
  from {
    stroke: #d62d20;
  }
  40% {
    stroke: #0057e7;
  }
  66% {
    stroke: #008744;
  }
  80%,
  90% {
    stroke: #ffa700;
  }
}
</style>